import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "director_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "choose_beneficiary_wrapper" }, null, -1)
const _hoisted_3 = { class: "director_title" }
const _hoisted_4 = { class: "director_title_buttons" }
const _hoisted_5 = { class: "director_inputs" }
const _hoisted_6 = { class: "inputs_block_header" }
const _hoisted_7 = { class: "inputs" }
const _hoisted_8 = { class: "director_inputs" }
const _hoisted_9 = { class: "inputs_block_header" }
const _hoisted_10 = { class: "inputs" }
const _hoisted_11 = { class: "director_inputs" }
const _hoisted_12 = { class: "inputs_block_header" }
const _hoisted_13 = { class: "inputs" }
const _hoisted_14 = { class: "photo_add_block" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "director_document_adding_wrapper" }
const _hoisted_17 = { class: "director_doc_add_block" }
const _hoisted_18 = { class: "director_doc_header" }
const _hoisted_19 = { class: "director_file_adding" }
const _hoisted_20 = { class: "director_doc_add_block" }
const _hoisted_21 = { class: "director_doc_header" }
const _hoisted_22 = { class: "director_file_adding" }
const _hoisted_23 = { class: "continue_block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_dropdown = _resolveComponent("ui-dropdown")!
  const _component_ui_button_delete = _resolveComponent("ui-button-delete")!
  const _component_ui_select = _resolveComponent("ui-select")!
  const _component_ui_input = _resolveComponent("ui-input")!
  const _component_ui_datetime_picker = _resolveComponent("ui-datetime-picker")!
  const _component_ui_select_autocomplete = _resolveComponent("ui-select-autocomplete")!
  const _component_ui_company_document_file = _resolveComponent("ui-company-document-file")!
  const _component_ui_company_document_adding_btn = _resolveComponent("ui-company-document-adding-btn")!
  const _component_continue_button = _resolveComponent("continue-button")!
  const _component_ui_message_error = _resolveComponent("ui-message-error")!
  const _component_loading = _resolveComponent("loading")!
  const _component_modal_camera = _resolveComponent("modal-camera")!
  const _directive_localization = _resolveDirective("localization")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Directors, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([
				'director_block_wrapper',
				index == _ctx.Directors.length - 1 ? 'main_target' : '',
			])
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_ui_dropdown, {
                items: _ctx.beneficiaries,
                "onUpdate:modelValue": ($event: any) => (_ctx.setBeneficiarData($event, index)),
                class: "beneficiaries_dropdown"
              }, null, 8, ["items", "onUpdate:modelValue"]),
              (index > 0)
                ? (_openBlock(), _createBlock(_component_ui_button_delete, {
                    key: 0,
                    onClick: ($event: any) => (_ctx.removeDirector(item))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$localization.getTranslate("Header.Director.DircetorInfo").toUpperCase()), 1),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_ui_select, {
                isWrong: _ctx.checkStart && item.Appeal.length == 0,
                class: "indentification-input",
                noUndefined: "true",
                modelValue: item.Appeal,
                "onUpdate:modelValue": ($event: any) => ((item.Appeal) = $event),
                items: _ctx.TitleOptions,
                headerText: _ctx.$localization.getTranslate('Header.Title') + '*'
              }, null, 8, ["isWrong", "modelValue", "onUpdate:modelValue", "items", "headerText"]),
              _createVNode(_component_ui_input, {
                headerText: _ctx.$localization.getTranslate('Header.Name') + '*',
                modelValue: item.FirstName,
                "onUpdate:modelValue": ($event: any) => ((item.FirstName) = $event),
                class: "indentification-input mt-0",
                isWrong: _ctx.checkStart && item.FirstName.length == 0
              }, null, 8, ["headerText", "modelValue", "onUpdate:modelValue", "isWrong"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.SecondName.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.Surname') + '*',
                modelValue: item.SecondName,
                "onUpdate:modelValue": ($event: any) => ((item.SecondName) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_datetime_picker, {
                isWrong: _ctx.checkStart && item.BirthDate == null,
                headerText: _ctx.$localization.getTranslate('Header.DateOfBirth') + '*',
                modelValue: item.BirthDate,
                "onUpdate:modelValue": ($event: any) => ((item.BirthDate) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.BirthPlace.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.PlaceOfBirth') + '*',
                modelValue: item.BirthPlace,
                "onUpdate:modelValue": ($event: any) => ((item.BirthPlace) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_select, {
                isWrong: _ctx.checkStart && item.DocumentType.length == 0,
                valueField: "doc",
                keyField: "doc",
                class: "indentification-input mt-4",
                noUndefined: "true",
                items: _ctx.documents,
                headerText: _ctx.$localization.getTranslate('Header.DocumentType') + '*',
                modelValue: item.DocumentType,
                "onUpdate:modelValue": ($event: any) => ((item.DocumentType) = $event)
              }, null, 8, ["isWrong", "items", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.DocumentNumber.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.DocumentNumber') + '*',
                modelValue: item.DocumentNumber,
                "onUpdate:modelValue": ($event: any) => ((item.DocumentNumber) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.DocumentIssuedBy.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.IssuedBy') + '*',
                modelValue: item.DocumentIssuedBy,
                "onUpdate:modelValue": ($event: any) => ((item.DocumentIssuedBy) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_datetime_picker, {
                isWrong: _ctx.checkStart && item.DocumentIssuedDate == null,
                headerText: _ctx.$localization.getTranslate('Header.DateOfIssue') + '*',
                modelValue: item.DocumentIssuedDate,
                "onUpdate:modelValue": ($event: any) => ((item.DocumentIssuedDate) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_datetime_picker, {
                isWrong: _ctx.checkStart && item.DocumentExpireDate == null,
                headerText: _ctx.$localization.getTranslate('Header.DateOfExpiry') + '*',
                modelValue: item.DocumentExpireDate,
                "onUpdate:modelValue": ($event: any) => ((item.DocumentExpireDate) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_select_autocomplete, {
                isWrong: item.DocumentIssuedCountryCode.length == 0 && _ctx.checkStart,
                modelValue: item.DocumentIssuedCountryCode,
                "onUpdate:modelValue": ($event: any) => ((item.DocumentIssuedCountryCode) = $event),
                keyField: "value",
                valueField: "text",
                items: _ctx.countries,
                class: "indentification-input",
                headerText: _ctx.$localization.getTranslate('Header.CountryOfIssuance') + '*',
                noUndefined: true
              }, null, 8, ["isWrong", "modelValue", "onUpdate:modelValue", "items", "headerText"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.Email.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.Email') + '*',
                modelValue: item.Email,
                "onUpdate:modelValue": ($event: any) => ((item.Email) = $event),
                class: "indentification-input mt-0"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.Phone.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.Phone') + '*',
                modelValue: item.Phone,
                "onUpdate:modelValue": [($event: any) => ((item.Phone) = $event), ($event: any) => (_ctx.onUpdatePhone($event, index))],
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$localization.getTranslate("Header.Company.RegisteredAddress").toUpperCase()), 1),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_ui_select_autocomplete, {
                isWrong: _ctx.checkStart && item.AddressCountryCode.length == 0,
                modelValue: item.AddressCountryCode,
                "onUpdate:modelValue": ($event: any) => ((item.AddressCountryCode) = $event),
                keyField: "value",
                valueField: "text",
                items: _ctx.countries,
                class: "indentification-input",
                headerText: _ctx.$localization.getTranslate('Header.Country') + '*',
                noUndefined: true
              }, null, 8, ["isWrong", "modelValue", "onUpdate:modelValue", "items", "headerText"]),
              _createVNode(_component_ui_input, {
                headerText: _ctx.$localization.getTranslate('Header.StateRegion'),
                modelValue: item.AddressState,
                "onUpdate:modelValue": ($event: any) => ((item.AddressState) = $event),
                class: "indentification-input"
              }, null, 8, ["headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.AddressCity.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.City') + '*',
                modelValue: item.AddressCity,
                "onUpdate:modelValue": ($event: any) => ((item.AddressCity) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.AddressZip.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.AddressZip') + '*',
                modelValue: item.AddressZip,
                "onUpdate:modelValue": ($event: any) => ((item.AddressZip) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.AddressStreet.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.Street') + '*',
                modelValue: item.AddressStreet,
                "onUpdate:modelValue": ($event: any) => ((item.AddressStreet) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                isWrong: _ctx.checkStart && item.AddressHome.length == 0,
                headerText: _ctx.$localization.getTranslate('Header.BuildingNumber') + '*',
                modelValue: item.AddressHome,
                "onUpdate:modelValue": ($event: any) => ((item.AddressHome) = $event),
                class: "indentification-input"
              }, null, 8, ["isWrong", "headerText", "modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_ui_input, {
                headerText: _ctx.$localization.getTranslate('Header.OfficeApartment'),
                modelValue: item.AddressApartment,
                "onUpdate:modelValue": ($event: any) => ((item.AddressApartment) = $event),
                class: "indentification-input"
              }, null, 8, ["headerText", "modelValue", "onUpdate:modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$localization.getTranslate("Header.Documents").toUpperCase()), 1),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                (item.FileUrl || (item.File && item.File.FileName))
                  ? (_openBlock(), _createBlock(_component_ui_company_document_file, {
                      key: 0,
                      fileName: item.FileUrl || (item.File && item.File.FileName),
                      onDeleteFile: ($event: any) => (_ctx.onClearFile(item)),
                      isUrl: item.FileUrl
                    }, null, 8, ["fileName", "onDeleteFile", "isUrl"]))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  onClick: ($event: any) => (_ctx.openModal(item)),
                  class: _normalizeClass(["take_photo", [
								!(item.FileUrl || (item.File && item.File.FileName)) && _ctx.checkStart
									? 'wrong'
									: '',
							]])
                }, _toDisplayString(_ctx.$localization.getTranslate("Button.TakeAPhoto") + "*"), 11, _hoisted_15),
                _withDirectives(_createElementVNode("span", {
                  class: _normalizeClass(["span_between", [
								!(item.FileUrl || (item.File && item.File.FileName)) && _ctx.checkStart
									? 'wrong_text'
									: '',
							]])
                }, null, 2), [
                  [_directive_localization, 'Or']
                ]),
                _createVNode(_component_ui_company_document_adding_btn, {
                  buttonColor: "#8e97a1",
                  buttonText: _ctx.$localization.getTranslate('Button.ChooseFile'),
                  isWrong: 
								!((item.File && item.File.FileBase64) || item.FileUrl) && _ctx.checkStart
							,
                  onAddedFile: ($event: any) => (_ctx.OnAddedFile(item, $event))
                }, null, 8, ["buttonText", "isWrong", "onAddedFile"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$localization.getTranslate("Passport") + "*"), 1),
                  _createElementVNode("div", _hoisted_19, [
                    (
										(item.DocumentFile && item.DocumentFile.FileName) ||
										item.DocumentFileUrl
									)
                      ? (_openBlock(), _createBlock(_component_ui_company_document_file, {
                          key: 0,
                          fileName: item.DocumentFileUrl || item.DocumentFile.FileName,
                          onDeleteFile: ($event: any) => (_ctx.deleteDocumentFile(item)),
                          isUrl: item.DocumentFileUrl
                        }, null, 8, ["fileName", "onDeleteFile", "isUrl"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ui_company_document_adding_btn, {
                      buttonColor: "#8e97a1",
                      buttonText: 
										(item.DocumentFile && item.DocumentFile.FileBase64) ||
										item.DocumentFileUrl
											? `${_ctx.$localization.getTranslate(
													'Identification.EditCompanyDocumentBtn'
											  )}`
											: `${_ctx.$localization.getTranslate('Button.AddDocument')}`
									,
                      isWrong: 
										!(
											(item.DocumentFile && item.DocumentFile.FileName) ||
											item.DocumentFileUrl
										) && _ctx.checkStart
									,
                      onAddedFile: ($event: any) => (_ctx.onAddDocumentFile(item, $event))
                    }, null, 8, ["buttonText", "isWrong", "onAddedFile"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$localization.getTranslate("Header.ApproveOfAddress") + "*"), 1),
                  _createElementVNode("div", _hoisted_22, [
                    (
										(item.ApproveOfAddressFile && item.ApproveOfAddressFile.FileBase64) ||
										item.ApproveOfAddressFileUrl
									)
                      ? (_openBlock(), _createBlock(_component_ui_company_document_file, {
                          key: 0,
                          fileName: 
										item.ApproveOfAddressFileUrl || item.ApproveOfAddressFile.FileName
									,
                          onDeleteFile: ($event: any) => (_ctx.deleteApproveOfAddressFile(item)),
                          isUrl: item.ApproveOfAddressFileUrl
                        }, null, 8, ["fileName", "onDeleteFile", "isUrl"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ui_company_document_adding_btn, {
                      buttonColor: "#8e97a1",
                      buttonText: 
										(item.ApproveOfAddressFile && item.ApproveOfAddressFile.FileBase64) ||
										item.ApproveOfAddressFileUrl
											? `${_ctx.$localization.getTranslate(
													'Identification.EditCompanyDocumentBtn'
											  )}`
											: `${_ctx.$localization.getTranslate('Button.AddDocument')}`
									,
                      isWrong: 
										!(
											(item.ApproveOfAddressFile &&
												item.ApproveOfAddressFile.FileBase64) ||
											item.ApproveOfAddressFileUrl
										) && _ctx.checkStart
									,
                      onAddedFile: ($event: any) => (_ctx.onAddApproveOfAdressDocument(item, $event))
                    }, null, 8, ["buttonText", "isWrong", "onAddedFile"])
                  ])
                ])
              ])
            ])
          ])
        ], 2))
      }), 128)),
      _withDirectives(_createElementVNode("button", {
        class: "director_add_btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addDirector && _ctx.addDirector(...args)))
      }, null, 512), [
        [_directive_localization, 'Button.Add']
      ]),
      _createElementVNode("div", _hoisted_23, [
        (!_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_continue_button, {
              key: 0,
              class: "business_continue_btn",
              onClicked: _ctx.saveAndContinue
            }, null, 8, ["onClicked"]))
          : _createCommentVNode("", true),
        _createVNode(_component_ui_message_error, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
          ]),
          _: 1
        }),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_loading, {
              key: 1,
              class: "continue_loading"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_modal_camera, {
      onCloseModal: _ctx.closeModal,
      visibility: _ctx.visibility,
      onPhoto: _ctx.takePhoto
    }, null, 8, ["onCloseModal", "visibility", "onPhoto"])
  ], 64))
}